import LightBox from '../components/LightBox'
import CreateTasksLightboxHeader from './CreateTasksLightboxHeader'
import CreateTasksLightboxContent from './CreateTaskLightboxContent'
import CreateTasksLightboxFooter from './CreateTasksLightboxFooter'
import messageResource from '../messageResource'

const NO_TASKS_FOR_CREATE_ERROR_MSG = 'add_new_tasks.there_are_no_tasks_to_create'
const INVALID_TASK_FIELDS_ERROR_MSG = 'add_new_tasks.js.footer_error.invalid_fields_exist'

class CreateTasksLightbox extends LightBox {
    constructor(serviceName,
                contentData = {},
                {
                    successTaskCreationCallback
                }) {
        super()

        this.params = {
            contentData,
            successTaskCreationCallback,
            serviceName
        }

        this.cancel_confirmation_message_key = "add_new_tasks.js.cancel_confirmation";
        this.close_tab_confirmation_message_key = "add_new_tasks.exit_confirmation";
        this.exist_invalid_fields_message_key = "add_new_tasks.js.footer_error.invalid_fields_exist";

        this._changesCallback = () => {
            this.getWrapper().update()
            this.dataChanged = true;
            this.updateErrors(true)
        }
    }


    init() {
        const header = new CreateTasksLightboxHeader()
        const footer = new CreateTasksLightboxFooter()
        const content = new CreateTasksLightboxContent(
            this.params.contentData,
            {
                onChangedDataCb: this._changesCallback,
                validationCb: this._validateCallback,
                getScrollPositionCallback: () => this.getScrollPosition()
            }
        )

        super.init({
            id: 'createTasksPopup', // do not delete
            header,
            content,
            footer,
            classNames: 'taskProjectOrCustomerLightbox lightboxWithWhiteContent',
            correctionOffset: 60
        })

        this.setSuccessCallback(() => {
                this.disableUserInputWhileSaving();

                this.components.content.sendCreateTasksRequest(this.params.serviceName)
                    .then((result) => {
                        this.enableUserInputWhileSaving();

                        if (!result.taskError && !result.billingTypeError && !result.containsCustomerProjectListError) {
                            if (this.params.successTaskCreationCallback) {
                                this.hide();
                                this.params.successTaskCreationCallback(result);
                            }
                            else {
                                document.location.reload();
                            }
                        }

                        if (result.customerProjectError || result.taskError) {
                            this.printErrorInFooter(messageResource.getMessage(INVALID_TASK_FIELDS_ERROR_MSG));
                        }

                        if (result.customerProjectError)
                            this.scrollToCustomerProjectSelector();
                        if (result.taskError)
                            this.scrollToFirstTaskWithError();
                    })
                    .catch((result) => {
                        this.enableUserInputWhileSaving()

                    })
            }
        );

        return this;
    }

    commit() {
        if (this.getContent().getTaskComponent().hideDescriptionPopup(true))
            super.commit(this);
    }

    getDataToCommit() {
        return this.getContent().getData()
    }

    hide() {
        this.getContent().getTaskComponent().hideDescriptionPopup();
        this.getContent().getTaskComponent().restoreGetOnPageDescriptionFunction();
        super.hide();
    }

    scrollToCustomerProjectSelector() {
        this.getWrapper().scrollToSection(this.getContent().getCustomerProjectSelectorSection());
    }

    scrollToTasksTable() {
        this.getWrapper().scrollToSection(this.getContent().getImportTasksContainer());
    }

    scrollToFirstTaskWithError() {
        // TODO replace with find task with error
        /*var taskWithErr = this.popupEl.find(".createTasksTable .nameCell .error");
        if (taskWithErr.get(0))
            this.getWrapper().scrollToSection(taskWithErr);
        else*/
            this.scrollToTasksTable();
    }

    hasErrors() {
        return this.getContent().hasErrors()
    }

    validate() {
        let errorMsgKey = INVALID_TASK_FIELDS_ERROR_MSG;

        if (this.getContent().validateCustomerProjectSelector()) {
            if (this.getContent().validateTasksTableComponent()) {
                return true;
            }

            if (this.getContent().isTaskTableComponentEmpty()) {
                errorMsgKey = NO_TASKS_FOR_CREATE_ERROR_MSG;
                this.scrollToTasksTable();
            } else {
                this.scrollToFirstTaskWithError();
            }
        }
        else
            this.scrollToCustomerProjectSelector();

        this.printErrorInFooter(messageResource.getMessage(errorMsgKey));
        this._blinkErrorInFooter();
        return false;
    }
}

export default CreateTasksLightbox



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTasksLightbox.js